import { render, staticRenderFns } from "./HomeVeranstalterSaiten.vue?vue&type=template&id=92181dc8&scoped=true"
import script from "./HomeVeranstalterSaiten.vue?vue&type=script&lang=ts"
export * from "./HomeVeranstalterSaiten.vue?vue&type=script&lang=ts"
import style0 from "./HomeVeranstalterSaiten.vue?vue&type=style&index=0&id=92181dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92181dc8",
  null
  
)

export default component.exports